import classnames from 'classnames';

import { useTheme } from '@classify/react-core-components/styles';

import withStyles from '@mui/styles/withStyles';

import Button from '@classify/react-core-components/Button';
import Typography from '@classify/react-core-components/Typography';

import MarketingHeadline from '../MarketingHeadline';

export const styles = ({ breakpoints, palette, spacing }) => ({
  root: {
    background: palette.brand.secondary,
    paddingTop: spacing(2),
    overflow: 'hidden',
  },

  headline: {
    margin: [[spacing(2), 0]],
  },

  wrapper: {
    margin: 'auto',
    width: breakpoints.values.xs,
    [breakpoints.up('sm')]: {
      width: breakpoints.values.sm,
      display: 'flex',
      flexDirection: 'row-reverse',
    },
    [breakpoints.up('md')]: {
      width: `calc(${breakpoints.values.md}px - ${spacing(7)})`,
    },
    [breakpoints.up('lg')]: {
      width: `calc(${breakpoints.values.lg}px - ${spacing(14)})`,
    },
  },

  content: {
    margin: [[spacing(3), 0]],
    color: `${palette.text.onContrasted} !important`,
    '& > *': {
      color: `${palette.text.onContrasted} !important`,
    },
  },

  contentContainer: {
    flexGrow: 1,
    padding: [[0, spacing(1)]],

    [breakpoints.up('sm')]: {
      padding: [[0, spacing(2)]],
    },
    [breakpoints.up('md')]: {
      padding: [[0, spacing(4)]],
    },
  },

  decorationContainer: {
    [breakpoints.up('sm')]: {
      alignSelf: 'flex-end',
      maxWidth: '40%',
      justifyContent: 'center',
    },

    '& > img': {
      display: 'block',
      margin: 'auto',
      maxHeight: 220,
      width: 'auto',
      [breakpoints.up('sm')]: {
        maxHeight: 'none',
        transform: 'translate(-15%,0)',
      },
      [breakpoints.up('md')]: {
        transform: 'none',
      },
    },
  },

  isMobileDecorationHidden: {
    '& $decorationContainer': {
      [breakpoints.down('sm')]: {
        display: 'none',
      },
    },
  },

  isReversed: {
    '& $wrapper': {
      flexDirection: 'row',
    },
    '& $decorationContainer': {
      '& > img': {
        [breakpoints.up('sm')]: {
          transform: 'translate(15%,0)',
        },
      },
    },
  },
});

function isNodeEmpty(node) {
  return !node || (typeof node === 'string' && !node.trim());
}

const HeaderPictureBanner = ({
  classes = {},
  headline = '',
  subheading = '',
  content = null,
  buttonLabel = '',
  buttonProps = {},
  decoration = null,
  isMobileDecorationHidden = false,
  isReversed = false,
}) => {
  const { palette } = useTheme();

  return (
    <div
      className={classnames(classes.root, {
        [classes.isMobileDecorationHidden]: isMobileDecorationHidden,
        [classes.isReversed]: isReversed,
      })}
    >
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          {(!isNodeEmpty(headline) || !isNodeEmpty(subheading)) && (
            <div className={classes.headline}>
              {!isNodeEmpty(headline) && (
                <MarketingHeadline color={palette.text.onMain}>{headline}</MarketingHeadline>
              )}
              {!isNodeEmpty(subheading) && (
                <MarketingHeadline component="h2" color={palette.text.onMain} variant="h4">
                  {subheading}
                </MarketingHeadline>
              )}
            </div>
          )}

          {content && (
            <Typography className={classes.content} component="div" variant="body">
              {typeof content === 'string' ? <p>{content}</p> : content}
            </Typography>
          )}

          {buttonLabel.trim() && (
            <Button sx={{ marginBottom: 3 }} isOnContrasted variant="primary" {...buttonProps}>
              {buttonLabel}
            </Button>
          )}
        </div>

        {decoration && <div className={classes.decorationContainer}>{decoration}</div>}
      </div>
    </div>
  );
};

export default withStyles(styles)(HeaderPictureBanner);
